import { render, staticRenderFns } from "./RSVPLandingPageDesigner.vue?vue&type=template&id=c8add8f8&scoped=true"
import script from "./RSVPLandingPageDesigner.vue?vue&type=script&lang=js"
export * from "./RSVPLandingPageDesigner.vue?vue&type=script&lang=js"
import style0 from "./RSVPLandingPageDesigner.vue?vue&type=style&index=0&id=c8add8f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8add8f8",
  null
  
)

export default component.exports